import { Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbComponent, BreadcrumbItem } from '../../../../shared/components/breadcrumb/breadcrumb.component';
import { LucideModule } from '../../../../shared/modules/lucide.module';
import {
  blocoDoCanal,
  PaginasAtendimentoPublicoService,
  ROTA_CANAIS,
} from '../../services/paginas-atendimento-publico.service';

/**
 * A página de um bloco de canal (`/outros-canais-atendimento/:canal/:bloco`), destino dos
 * comportamentos "Abrir Página Interna" e "Abrir Nova Aba". O canal e o bloco chegam pelo
 * slug do nome e são achados entre os canais publicados: vale para qualquer bloco publicado,
 * qualquer que seja o comportamento dele.
 */
@Component({
  selector: 'app-canal-bloco',
  templateUrl: './canal-bloco.component.html',
  styleUrls: ['./canal-bloco.component.css'],
  imports: [BreadcrumbComponent, LucideModule, RouterLink],
})
export class CanalBlocoComponent {
  private readonly paginasAtendimento = inject(PaginasAtendimentoPublicoService);

  readonly canal = input('');

  readonly bloco = input('');

  private readonly canais = this.paginasAtendimento.canais();

  readonly carregando = this.canais.carregando;

  readonly erro = this.canais.erro;

  readonly encontrado = computed(() => blocoDoCanal(this.canais.secoes(), this.canal(), this.bloco()));

  readonly titulo = computed(() => this.encontrado()?.bloco.titulo ?? 'Canal de atendimento');

  /**
   * Lidos só no uso: a constante importada lida num inicializador de campo pode nascer
   * indefinida na suíte de testes.
   */
  readonly trilha = computed<readonly BreadcrumbItem[]>(() => [
    { titulo: 'Outros canais de atendimento', link: ROTA_CANAIS },
  ]);

  get rotaCanais(): string {
    return ROTA_CANAIS;
  }

  tentarNovamente(): void {
    this.canais.recarregar();
  }
}
